import React from "react";
import Landing from "./../containers/LandingContainer";
// import LogoAlcaldia from "./../../images/LogoAlcaldia.png";

function notFound({ history }) {
  return (
    <div>
      
      <div className="background-image">
        <Landing history={history} hasFooter={true}>
          <div>
          <div className="line line-100"></div>
            <div className="Message-404 Message-404-text-m">
              ¡El contenido que buscabas no se ha encontrado!
            </div>
            <div className="Message-404 Message-404-text-s">
              Probablememnte la información ha cambiado de ubicación
            </div>
            <div className="Message-404 Message-404-text-l">Error 404</div>
            {/* <div>
              <img
                src={LogoAlcaldia}
                alt="Alcaldia"
                className="alcaldia-logo"
              ></img>
            </div> */}
          </div>
        </Landing>
      </div>
    </div>
  );
}

export default notFound;
